webpackJsonp([174759485231550],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cotb2018 = function Cotb2018() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h1",
	      null,
	      "Code on the Beach 2018"
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://docs.google.com/presentation/d/1dhbL29CHw__viP52UnmMXvMFWqZNpxa_FYyrmWmecWg/edit?usp=sharing" },
	          "Google Slides"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://github.com/jdomizio/cotb2018" },
	          "Code Examples"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://github.com/jdomizio/guess.domiz.io" },
	          "guess.domiz.io SignalR app"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "http://guess.domiz.io" },
	          "Link to guessing game (guess.domiz.io)"
	        )
	      )
	    )
	  );
	};
	
	exports.default = Cotb2018;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cotb-2018-js-8c1bf17a340d89c8431b.js